/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: partner-planner-searchview-component.js
 *
 * Created by psnyder on 02/15/17.
 */

'use strict';

function PartnerPlannerSearchViewController ($location, uiGridConstants, PartnerEditService, ModalService,
											 NavbarUtilService, UtilsService) {
    var self = this;


    //=================//
	// Lifecycle Hooks //
	//=================//

	self.$onInit = function () {
		self.queryForGridData();
	};


    //==========//
	// Pacifier //
	//==========//

	self.loadingIndicator = {
		backdrop: true,
		show: false,
		title: 'Working',
		message: 'Please wait...'
	};


	//======//
	// Grid //
	//======//

	self.gridApi = null;
	self.searchText = null;

	self.gridColumnDefs = [
		{
			field: 'id',
			type: 'number',
			width: '60',
			displayName: 'ID',
			cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
		},
		{
			field: 'name',
			width: '*',
			displayName: 'Name',
			sort: {
				direction: 'asc',
				priority: 1
			},
			cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
		},
		{
			field: 'enabledFlag',
			type: 'boolean',
			maxWidth: 95,
			displayName: 'Enabled',
			cellTemplate: 'components/visual/grid/radio-button-template.html'
		},
		{
			field: 'lookBack',
			type: 'number',
			width: 100,
			displayName: 'Back',
			cellTemplate: 'components/visual/grid/day-count-template.html'
		},
		{
			field: 'lookForward',
			type: 'number',
			width: 100,
			displayName: 'Forward',
			cellTemplate: 'components/visual/grid/day-count-template.html'
		},
		{
			field: 'scheduleLabel',
			width: 245,
			displayName: 'Schedule / Interval',
		},
		{
			field: 'nextRun',
			width: 220,
			maxWidth: 220,
			displayName: 'Next Run',
			cellFilter: 'amDateFormat:"MMM D, YYYY, h:mm A"',
			sort: {
				direction: 'desc',
				priority: 0
			},
			sortingAlgorithm: function (a, b) {
				return (
					(!!a? new Date(a).getTime() : 0) -
					(!!b? new Date(b).getTime() : 0)
				);
			},
			cellTemplate: 'system/partner/editor/components/view/planner/searchView/gridTemplates/next-run-cell-template.html'
		},
		{
			field: 'xslTemplate.name',
			width: '*',
			displayName: 'XSL Template',
			cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
		},
		{
			field: 'emailEndpoint.name',
			width: '*',
			displayName: 'Email Endpoint',
			cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
		},
		{
			field: 'deliveryEndpoint.name',
			width: '*',
			displayName: 'Delivery Endpoint',
			cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
		}
	];

	self.gridOptions = {
		rowSelection: true,
		enableRowHeaderSelection: false,
		enableSelectAll: true,
		enableColumnResizing: true,
		enablePaginationControls: false,
		enableSorting: true,
		enableColumnMenus: false,
		enableFullRowSelection: true,
		enableHorizontalScrollbar: uiGridConstants.ALWAYS,
		enableVerticalScrollbar: uiGridConstants.ALWAYS,
		multiSelect: false,
		columnDefs: self.gridColumnDefs,
		onRegisterApi: function(gridApi) {
			self.gridApi = gridApi;
			self.gridApi.grid.registerRowsProcessor(self.processGridFilter, 200);
		},
		rowTemplate: 'system/partner/editor/components/view/planner/searchView/gridTemplates/planner-row-template.html',
		data: []
	};

	self.onRowDblClick = function (row) {
		self.editPlanner(row.entity.id);
	};

	self.filterGrid = function (searchText) {
		if (searchText !== null) {
			self.searchText = searchText.toLowerCase();
		}
        self.gridApi.selection.clearSelectedRows();
        self.gridApi.grid.refresh();
	};

	self.processGridFilter = function (renderableRows) {
		renderableRows.forEach(function (row) {
			row.visible = (self.searchText === null)?
				true:
				row.entity.name.toLowerCase().indexOf(self.searchText) !== -1;
		});
		return renderableRows;
	};

	self.createNextRunLabel = function (planner) {
		if (!planner.enabledFlag || !UtilsService.hasData(planner.nextRun)) {
			return null;
		}

		var runByDate = new Date(planner.nextRun).valueOf();
		if (runByDate >= Date.now()) {
			return runByDate;
		} else {
			return null;
		}
	};


	//======//
	// Data //
	//======//

	self.queryForGridData = function () {
		self.loadingIndicator.show = true;

		PartnerEditService.getPlannerSearchViewData().then(function (plannerData) {
			self.gridOptions.data = plannerData.planners;
			self.partnerObject = plannerData.partnerObject;
			self.searchText = $location.search().searchText || null;
			self.filterGrid(self.searchText);

			self.loadingIndicator.show = false;
		});
	};


	//=================//
	// Planner Actions //
	//=================//

	self.newPlanner = function () {
		$location.url('/system/partners/edit/' + self.partnerObject.id + '/planner/edit/-1');
	};

	self.editPlanner = function (id) {
		$location.url('/system/partners/edit/' + self.partnerObject.id + '/planner/edit/' + id);
	};

	self.deleteSelectedPlanner = function () {
		PartnerEditService.deletePlanner(self.gridApi.selection.getSelectedRows()[0]).then(function () {
			self.queryForGridData();
		});
	};

	var showDeleteConfirmationModal = function () {
		ModalService.showMessageModal({
				messageText: 'Are you sure you want to delete "' + self.gridApi.selection.getSelectedRows()[0].name + '"?',
				title: 'Delete Partner Planner',
				windowClass: 'confirm-modal-sm',
				showOK: true,
				okText: 'Yes',
				pullCancelLeft: true
			},
			function () { self.deleteSelectedPlanner(); },
			function () {}
		);
	};


	//=========//
	// Toolbar //
	//=========//

	self.toolbarButtonDefs = [
		{
			label: 'New',
			enabled: function () { return true; },
			onClick: function () { self.newPlanner(); },
		},
		{
			label: 'Edit',
			enabled: function () { return self.gridApi.selection.getSelectedCount() === 1; },
			onClick: function () { self.editPlanner(self.gridApi.selection.getSelectedRows()[0].id); },
		},
		{
			label: 'Delete',
			enabled: function () { return self.gridApi.selection.getSelectedCount() >= 1; },
			onClick: function () { showDeleteConfirmationModal(); },
		}
	];

	// Navbar search button click handler
	NavbarUtilService.viewSearchFunction = self.queryForGridData;
}

angular.module('prism-ui.partner').component('partnerPlannerSearchView', {
	templateUrl: 'system/partner/editor/components/view/planner/searchView/partner-planner-searchview-template.html',
	controller: PartnerPlannerSearchViewController,
	bindings: { }
});
